// src/views/auth/SignIn.tsx
import React, { useState, useContext } from "react";
import InputField from "components/fields/InputField";
import { AuthContext } from "context/AuthContext";
import { useNavigate } from "react-router-dom"; // if using react-router
import { toast } from "react-toastify";
import { Button } from "components/ui";

export default function SignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  // Update the handleSignIn function to receive the event
  const handleSignIn = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevents page refresh

  // Normalize username to lowercase and trim whitespace
  const normalizedUsername = username.toLowerCase().trim();

    try {
      setSubmitting(true);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          username: normalizedUsername,  // Use normalized username
          password 
      }),
      });

      if (!response.ok) {
        const data = await response.json();
        toast.error(data.error || "Error de inicio de sesión");
        return;
      }

      const data = await response.json();
      
      // Call login with token and user data (make sure your API returns these fields)
      login(data.token, data.refreshToken, {
        username: data.username,
        firstName: data.firstName,
        lastName: data.lastName
      });
      
      navigate('/');
      toast.success("Inicio de sesión con éxito");
    } catch (error) {
      console.error(error);
      toast.error("Hubo un error al iniciar sesión");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full select-none">
      <h1 className="text-[30px] font-bold leading-tight text-gray-900 dark:text-white">
        Iniciar sesión
      </h1>
      <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-400">
        Ingresá tu nombre de usuario y contraseña para continuar.
      </p>

      {/* Wrap inputs and button in a form */}
      <form onSubmit={handleSignIn} className="mt-8 space-y-4">
        {/* Username */}
        <InputField
          variant="auth"
          extra=""
          label="Nombre de usuario"
          placeholder="Usuario"
          id="username"
          type="text"
          value={username}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            // Optional: Prevent spaces in username
            setUsername(e.target.value.replace(/\s/g, ''))
          }
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra=""
          label="Contraseña"
          placeholder="Contraseña"
          id="password"
          type="password"
          value={password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
        />

        <Button
          type="submit"
          variant="primary"
          size="lg"
          fullWidth
          loading={submitting}
          className="!mt-6"
        >
          Iniciar sesión
        </Button>
      </form>
    </div>
  );
}
